import { render } from "./Main.vue?vue&type=template&id=53798d9f&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.scss?vue&type=style&index=0&id=53798d9f&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/less-mess/less-mess/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53798d9f"]])

export default __exports__